import styled from 'styled-components';
import { pallette } from '../../config/pallette';

export const Container = styled.div`
  background-color: ${pallette.white};
  position: absolute;
  width: 100%;
  height: calc(100dvh - 80px);
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  z-index: 100;
`;

export const MenuItem = styled.button`
  display: flex;
  gap: 20px;
  align-items: center;
  width: 92%;
  margin-top: 20px;
  background-color: transparent;
  border: none;
  padding: 0;
`;

export const MenuItemTitle = styled.p`
  width: 85px;
  font-weight: bold;
  font-size: 18px;
  text-decoration: ${`underline 4px ${pallette.main}`};
  text-underline-offset: 10px;
`;

export const MenuItemLink = styled.a`
  width: 85px;
  color: black;
  font-size: 18px;
  text-decoration: underline 1px;
  text-underline-offset: 2px;
`

export const PreviousChatsContainer = styled.div`
  text-align: left;
  width: 92%;
  height: 100%;
  overflow-y: auto;
`

export const ChatHistoryTitle = styled.p`
  font-weight: bold;
  font-size: 12px;
  width: 92%;
  margin: 0;
  padding: 0;
`

export const ConversationMenuItem = styled.div`
  background-color: ${({ selected }) => selected ? pallette.highlight : 'transparent'};
  height: 50px;
  display: flex;
  padding-left: ${({ selected }) => selected ? "10px" : '0'};
`

export const ConversationTitle = styled.p`
  color: black;
`

export const ShadowContainer = styled.div`
  box-shadow: 0px -3px 3px 0px rgba(0, 0, 0, 0.2);
  width: 100%;
`

export const BottomContainer = styled.div`
  margin: 0 auto 30px;
  width: 92%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
`

export const LogoutButton = styled.button`
  background-color: ${pallette.main};
  color: ${pallette.white};
  border: none;
  height: 45px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
`;